// eslint-disable-next-line import/prefer-default-export
export const parseDate = (value: string) => {
  let year;
  let month;
  let day;
  if (value.includes('-')) {
    [day, month, year] = value.split('-');
  } else {
    year = value.slice(0, 4);
    month = value.slice(4, 6);
    day = value.slice(6);
  }
  const dob = { year, month, day };
  return dob;
};
